import { fUploader } from '../../modules/fUploader';
import { BlankInfo } from '../../modules/BlankInfo';

export const BlankUpload = (function () {
  let $fupExcel = null,
    $fupMockups = null,
    $fupModels = null;

  let $modalContent,
    $uploadBtn,
    $required,
    $files,
    $completedFiles,
    $uploadCallback;

  let dialog = (uploadCallback, required = true) => {
    $required = required;
    $uploadCallback = uploadCallback;

    $files = {};
    $completedFiles = {};

    let template = require('./tmpl/dialog/addFiles.hbs');

    bootbox
      .dialog({
        title: $lang.blankUpload.blankUpload,
        message: template({ $lang: $Lang, required }),
        size: 'large',
        className: 'modal-blankUpload',
        buttons: {
          ok: {
            label: $lang.btn.Import,
            className: 'btn btn-brand blankUpload-upload-button',
            callback: uploadStart
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(() => dialogInit());
  };

  let dialogInit = () => {
    $modalContent = '.modal-blankUpload .modal-content';
    $uploadBtn = $('.modal-blankUpload .blankUpload-upload-button');

    fupInit();
  };

  const fupInit = () => {
    $uploadBtn.prop('disabled', true);

    $fupExcel = new fUploader('#blankUploadDialog input.excel', {
      extensions: ['xlsx'],
      suitabilityViewExtensions: ['xlsx'],
      blockEl: $modalContent,
      validate: validate.bind(null, 'excel'),
      complete: complete.bind(null, 'excel'),
    });

    $fupMockups = new fUploader('#blankUploadDialog input.zipMockups', {
      extensions: ['zip'],
      blockEl: $modalContent,
      validate: validate.bind(null, 'zipMockups'),
      complete: complete.bind(null, 'zipMockups'),
    });

    $fupModels = new fUploader('#blankUploadDialog input.zipModels', {
      extensions: ['zip'],
      blockEl: $modalContent,
      validate: validate.bind(null, 'zipModels'),
      complete: complete.bind(null, 'zipModels'),
    });
  };

  let complete = (fileType, file) => {
    $completedFiles[fileType] = file;

    if (Object.values($completedFiles)?.length !== Object.values($files)?.length) {
      return;
    }

    if ($uploadCallback) {
      $uploadCallback($completedFiles);
    }
  };

  let validate = (fileType, data) => {
    $files[fileType] = data;

    $uploadBtn.prop('disabled', $required ? Object.values($files)?.length < 3 : !Object.values($files)?.length);
  };

  let uploadStart = (e) => {
    $fupExcel.uploadStart();
    $fupMockups.uploadStart();
    $fupModels.uploadStart();

    return false;
  };

  let blankInfoDialog = (id = false, callback, readOnly = false, isModelImagesInfo = false) => {
    BlankInfo.dialog(id, callback, readOnly, isModelImagesInfo);
  };

  return {
    blankInfoDialog,
    dialog,
    closeDialog: bootbox.hideAll,
  };
})();
